<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div [class.isPrinting]="printService.isPrinting">


  <div class="job-posts placements agreements margin-top-service-30px">
    <div class="card my-profile-form skillassest-form">



    </div>
    <div class="card-body padding-top padding-cleft-0px padding-right-0px">
      <div class="row">
        <div class="col-md-3 padding-right-0px colmd3">
          <div class="position-fixed-scans border-right2 padding-right-5px height-100pe">
            <div class="card height-100pe">

              <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-0">
                <div class="row margin-top10px margin-left-20px  nav-link-hand">
                  <div class="col-md-10 padding-left-0px">
                    <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                      Insemination
                    </label>
                  </div>


                  <!--<div class=" col-md-2 padding-left-0px col-sm-4 text-align-right padding-right-10px">

                    <label for="diaplayName " class="font-size-15px margin-top-5px margin-bottom-0px">Date</label>
                  </div>-->


                  <div class="col-md-1">
                    <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
                  </div>
                  <!--<a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Services"
                  *ngIf="ShowIcon"><i class="fas fa-angle-double-left font-size-19px"></i></a>-->

                </div>




              </div>
              <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-right-0px padding-bottom-0px">
                <div class="row border-top margin-left-0px margin-right-0px">
                  <div class="col-md-5 col-sm-4 padding-right-0px my-profile-form margin-left-10px">
                    <div class="date-form margin-top-5px form-group margin-bottom-0px">
                      <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>



                  </div>
                  <div class="col-md-1 " (click)="DecrementDate()">
                    <a title="Previous" class="nav-link-hand">
                      <i class="fas fa-caret-left margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                  <div class="col-md-1 padding-left-0px padding-right-0px" (click)="IncrementDate()">
                    <a title="Next" class="nav-link-hand">
                      <i class="fas fa-caret-right margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                </div>
                <div class="row  margin-right-0px margin-left-0px">
                  <div class="col-md-11 margin-bottom-10px margin-top-10 margin-left-10px padding-right-0px padding-left-10px">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                    <!--<input type="search"  [title]="searchTitle"  (change)="criteriaChange($event)" class="form-control padding-bottom-2px width-230px margin-top-10 margin-bottom-10px" placeholder="Search....">-->
                  </div>
                  <div class="col-md-2" hidden>
                    <button type="button" class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Edit">
                      <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                    </a>

                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Delete">
                      <span class="badge font-size-14">
                        <i class="far fa-trash-alt"></i>
                      </span>
                    </a>
                  </div>

                </div>
                <div>
                  <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps scroll padding-lrt " data-ps-id="dfsfsde">

                    <!--<div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient()">
                      <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient()">
                        <img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">



                      </div>
                      <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="margin-bottom-0px">Ramya santhosh</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">32 years,GGHOI/027</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-4">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">9899989891</label>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-3 padding-left-0px margin-top-5px">
                        <div class="text-align-center">
                          <i class="fas fa-check-circle color-icon-completed "></i>
                        </div>
                        <div class="text-align-center"><label class="font-size-12px">10:30</label></div>
                      </div>
                    </div>
                    <div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient()">
                      <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient()">
                        <img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">



                      </div>
                      <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="margin-bottom-0px">Ramya santhosh</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">32 years,GGHOI/027</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-4">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">9899989891</label>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-3 padding-left-0px margin-top-5px">
                        <div class="text-align-center">
                          <i class="fas fa-check-circle color-icon-completed "></i>
                        </div>
                        <div class="text-align-center"><label class="font-size-12px">10:30</label></div>
                      </div>
                    </div>-->
                    <div *ngIf="isRequesting">
                      <div class="loader-text">
                        <div class="loader-text2">

                          <div class="lds-facebook">
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                          <div class="margin-top-20px margin-left-5px">
                            <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                          </div>
                          <!--Loading Please Wait...-->
                        </div>
                      </div>
                      <!--<div class="loadernew"></div>-->


                    </div>
                    <div *ngIf="!isRequesting">
                      <div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient(l)" *ngFor="let l of pdata">
                        <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient(l)">
                          <img class="user-image-circle-65px img2 margin-left-6px" [src]="l.OwnerPatientImageFile" onError="this.src='dummy.jpg';">



                        </div>
                        <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="margin-bottom-0px td-elipsis-scan font-size-14">{{l.OwnerName}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerAgeYears}} years,{{l.OwnerFormattedCode}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-4">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerTelephone1}}</label>
                            </div>
                          </div>

                        </div>

                        <div class="col-md-3 padding-left-0px margin-top-5px">
                          <div class="text-align-center"><label class="font-size-12px">#{{l.CycleNo}}</label></div>
                          <div class="text-align-center">
                            <a data-toggle="tooltip" data-placement="bottom" title="Completed" *ngIf="l.ActivityStatus=='Completed'">

                              <i class="fas fa-check-circle color-icon-completed font-size-16px">
                              </i>
                            </a>
                            <a data-toggle="tooltip" data-placement="bottom" title="Initiated" *ngIf="l.ActivityStatus=='Initiated'">

                              <i class="fas fa-check-circle color-gray font-size-16px">
                              </i>
                            </a>
                          </div>
                          <!--<div class="text-align-center"><label class="font-size-12px">{{l.LastUpdatedTime | date: 'hh:mm a'}}</label></div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>

        <div class="col-md-6 padding-left-3px padding-right-8px" *ngIf="ScanDetails">

          <div class="row">
            <div class="col-md-12 padding-left-0px">
              <div class="card">
                <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px">
                  <div class="row">
                    <div class="col-md-1 ">
                      <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.EggPatientImageFile" onError="this.src='dummy.jpg';">
                    </div>
                    <div class="col-md-4 margin-left-18">
                      <div class="row row-height-17px margin-left-0px">
                        <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.EggName}}</label>
                      </div>

                      <div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>
                      <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>-->
                      <div class="row row-height-17px">
                        <div class="col-md-12">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.EggAgeYears}},{{SelectedpatientDetails.EggFormattedCode}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-4">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.EggTelephone1}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-3">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">Cycle#{{SelectedpatientDetails.CycleNo}},</label>
                        </div>
                        <div class="col-md-9 padding-left-6px">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">Start Date: {{SelectedpatientDetails.ProtocolStartDate | date:'MMM-dd-yyyy'}}</label>
                        </div>

                      </div>
                    </div>
                    <div class="col-md-6  padding-right-0px">
                      <!--<div class="row font-size-12px">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="InseminationData2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{InseminationData2.LastUpdatedTime | date: 'hh:mm a'}}</label>
                        </div>
                      </div>-->
                      <div class="row font-size-12px">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="InseminationData2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{InseminationData2.ActivityStatus}}</label>
                        </div>
                      </div>
                      <div class="row margin-right-0px" hidden>
                        <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
                        </div>
                        <div class="Dsa2" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
                        </div>
                        <div class="Dsa3" *ngIf="DSADetails">

                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
                        </div>

                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-body padding-right-0px padding-top-0px">
                  <div class="card">
                    <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
                      <div class="row nav-link-hand margin-right-0px" id="edit-link">
                        <div class="col-md-6 padding-right-0px">
                          <label class="margin-bottom-0px font-size-16px font-weight-normal">
                            Insemination
                          </label>
                        </div>
                        <div class="col-md-5  padding-right-0px display-edit">
                          <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                          <div class="row float-right" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                            <!--<div class="offset-md-3 col-md-1 margin-top-3px padding-left-0px">

                            </div>
                            <div class="col-md-1">
                              <button type="button"
                                      class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
                                      name="upload">
                                <i class="fas fa-plus font-size-11"></i>
                              </button>
                            </div>-->
                            <div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="InseminationData2">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="Insemination()" title="Is Insemination Completed" *ngIf="InseminationData2.ActivityStatus !=='Completed'">Is Insemination Completed</a>
                            </div>

                            <div class="col-md-1" *ngIf="InseminationData2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printinsemi()" *ngIf="InseminationData2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>

                          </div>


                          <div class="row" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture' && SelectedpatientDetails.CycleType!=='IUI'">
                            <!--<div class="offset-md-3 col-md-1 margin-top-3px padding-left-0px">

                            </div>
                            <div class="col-md-1">
                              <button type="button"
                                      class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
                                      name="upload">
                                <i class="fas fa-plus font-size-11"></i>
                              </button>
                            </div>-->
                            <div class="col-md-10 margin-top-3px padding-left-0px" *ngIf="InseminationData2">
                              <a class="nav-link-hand patientreg-link float-right padding-top-5px font-weight-normal display-edit" (click)="Insemination()" title="Is Insemination Completed" *ngIf="InseminationData2.ActivityStatus !=='Completed'">Is Insemination Completed</a>
                            </div>


                            <div class="col-md-1" *ngIf="InseminationData2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printinsemidroplet()">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                              <!--<a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printinsemidroplet()" *ngIf="InseminationData2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>-->
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture' && SelectedpatientDetails.CycleType=='IUI'">
                            <!--<div class="offset-md-3 col-md-1 margin-top-3px padding-left-0px">

                            </div>
                            <div class="col-md-1">
                              <button type="button"
                                      class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
                                      name="upload">
                                <i class="fas fa-plus font-size-11"></i>
                              </button>
                            </div>-->
                            <div class="col-md-10 margin-top-3px padding-left-0px" *ngIf="InseminationData2">
                              <a class="nav-link-hand patientreg-link float-right padding-top-5px font-weight-normal display-edit" (click)="InseminationIUI()" title="Is Insemination Completed" *ngIf="InseminationData2.ActivityStatus !=='Completed'">Is Insemination Completed</a>
                            </div>


                            <div class="col-md-1" *ngIf="InseminationData2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printinsemidroplet()">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                              <!--<a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printinsemidroplet()" *ngIf="InseminationData2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>-->
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                      <div class="card-body padding-top-0px">

                        <div class="accordion margin-bottom-20px margin-top-20px" id="accordionExample6" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                          <div class="card margin-bottom-5px">
                            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingSix">
                              <div class="row">
                                <div class="col-md-4 padding-right-0px">
                                  <h5 class="mb-0 height-24px margin-top-5px">
                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                                      Oocytes for Insemination
                                    </button>
                                  </h5>
                                </div>
                                <div class="col-md-1 padding-left-0px">
                                  <div class="badge badge-search padding-right-7px padding-left-7px"><h4 class="margin-bottom-0px margin-top-1px">{{length}}</h4></div>
                                </div>
                                <div class="col-md-7 ">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                  <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" hidden>Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                </div>
                              </div>


                            </div>

                            <div id="collapseSix" class="collapse show" aria-labelledby="headingSix" data-parent="#accordionExample6">
                              <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                <div class="row">
                                  <div class="col-md-12 padding-left-0px">
                                    <div class="table-component" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero overflow-y-hidden">

                                          <thead class="">
                                            <tr>
                                              <th class="min-width-0px padding-top-4px padding-bottom-4px"></th>

                                              <th class="padding-top-4px padding-bottom-4px">Sno</th>
                                              <th class="padding-top-4px padding-bottom-4px">Well#</th>
                                              <th class="padding-top-4px padding-bottom-4px">Occ/Denuded</th>
                                              <th class="padding-top-4px padding-bottom-4px">Morphology</th>
                                              <th class="white-space-preline padding-top-4px padding-bottom-4px">Technique</th>
                                              <th class="padding-top-4px padding-bottom-4px" *ngIf="InseminationData2.ActivityStatus !=='Completed'"></th>
                                            </tr>
                                          </thead>
                                          <tbody class="table-body">
                                            <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                            <!--</ng-container>-->
                                            <tr *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">
                                              <td class="td-padding padding-all-0px ">

                                                <input type="checkbox" name="l.IsSelected"
                                                       [(ngModel)]="l.IsSelected">
                                                <i class="input-helper"></i>

                                              </td>

                                              <td class="text-align-center padding-all-0px">{{i+1}}</td>
                                              <td class="text-align-center padding-all-0px">{{l.WellNo}}</td>
                                              <td class="td-padding padding-all-0px text-align-center">{{l.OocyteQualityPre}}/{{l.OocyteQualityPost}}</td>
                                              <td class="td-padding padding-all-0px text-align-center">{{l.Morphology}}</td>
                                              <td class="padding-all-0px">
                                                <CodeTypeValue CodeType="InsTe" [(ngModel)]="l.technique" SelectedValue="l.technique"
                                                               required></CodeTypeValue>
                                              </td>

                                              <td class="text-align-center padding-all-0px" *ngIf="InseminationData2.ActivityStatus !=='Completed'">
                                                <button type="submit" (click)="onSubmit(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l?.IsSelected"><i class="far fa-save"></i></button>


                                              </td>



                                            </tr>
                                          </tbody>

                                        </table>

                                      </div>
                                    </div>
                                    <div class="table-component" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero overflow-y-hidden">

                                          <thead class="">
                                            <tr>
                                              <th class="min-width-0px padding-top-4px padding-bottom-4px"></th>

                                              <th class="width100px">
                                                Group ID
                                              </th>


                                              <th class="td-well-width-79px">
                                                ID
                                              </th>
                                              <th class="padding-top-4px padding-bottom-4px">Occ/Denuded</th>
                                              <th class="padding-top-4px padding-bottom-4px">Morphology</th>
                                              <th class="white-space-preline padding-top-4px padding-bottom-4px">Technique</th>
                                              <th class="padding-top-4px padding-bottom-4px" *ngIf="InseminationData2.ActivityStatus !=='Completed'"></th>
                                            </tr>
                                          </thead>
                                          <tbody class="table-body">
                                            <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                            <!--</ng-container>-->
                                            <tr *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">
                                              <td class="td-padding padding-all-0px ">

                                                <input type="checkbox" name="l.IsSelected"
                                                       [(ngModel)]="l.IsSelected">
                                                <i class="input-helper"></i>

                                              </td>
                                              <td class="padding-all-0px text-align-center width-th-52px">


                                                <CodeTypeValue CodeType="EMGRP"
                                                               required>
                                                </CodeTypeValue>

                                              </td>
                                              <td class="padding-all-0px">


                                                <input type="text" class="form-control" placeholder=""
                                                       maxlength="2" required>
                                                <!--<small class="form-text text-danger"
                                                       *ngIf="(!Well.valid && (Well.dirty || Well.touched) && Well.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Well.valid && Well.errors.pattern)">(special characters are not allowed)</small>-->
                                              </td>

                                              <td class="td-padding padding-all-0px text-align-center">{{l.OocyteQualityPre}}/{{l.OocyteQualityPost}}</td>
                                              <td class="td-padding padding-all-0px text-align-center">{{l.Morphology}}</td>
                                              <td class="padding-all-0px">
                                                <CodeTypeValue CodeType="InsTe" [(ngModel)]="l.technique" SelectedValue="l.technique"
                                                               required></CodeTypeValue>
                                              </td>

                                              <td class="text-align-center padding-all-0px" *ngIf="InseminationData2.ActivityStatus !=='Completed'">
                                                <button type="submit" (click)="onSubmit(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l?.IsSelected"><i class="far fa-save"></i></button>


                                              </td>



                                            </tr>
                                          </tbody>

                                        </table>

                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card margin-top-10" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                          <!--<div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
                            <div class="row nav-link-hand margin-right-0px" id="edit-link">
                              <div class="col-md-6 padding-right-0px">
                                <label class="margin-bottom-0px font-size-16px font-weight-normal">
                                  Insemination Log
                                </label>
                              </div>
                              <div class="col-md-6  padding-right-0px display-edit">

                                <div class="row float-right">

                                  <div class="col-md-1">
                                    <a class="nav-link-hand education-navlink data-color-new" title="print">
                                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                                    </a>
                                  </div>
                                </div>




                              </div>

                            </div>
                          </div>-->
                          <div class="card-body padding-all-0px">
                            <div class="accordion margin-bottom-20px margin-top-10" id="accordionExample1">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                          Insemination Log
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="InseminationData2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="button"
                                              class="btn  btn-sm button-ivfactivity  background-primary border-all-secondary float-right" id="FileUpload" (click)="Addactivity()"
                                              name="upload" *ngIf="InseminationData2.ActivityStatus !=='Completed'">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                    </div>
                                  </div>


                                </div>

                                <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample1">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="card margin-bottom-0px background-lightpink">

                                          <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                            <div class="table-component margin-bottom-0px padding-all-5px">
                                              <div class="table-responsive">


                                                <table class="table table-striped margin-left-zero overflow-y-hidden">

                                                  <thead class="">
                                                    <tr>
                                                      <th class="min-width-0px">Date &amp; Time</th>

                                                      <th class="min-width-0px">No of times per hour</th>
                                                      <th class="padding-left-5px">Processed By</th>

                                                      <th>Doctor</th>
                                                      <th></th>
                                                    </tr>
                                                  </thead>
                                                  <tbody class="table-body">

                                                    <tr *ngFor="let l of CurrentIvfCycleInseminationLogByCycleWithDOCController">
                                                      <td class="td-padding">


                                                        {{l.InseminationDate| date:'dd-MMM-yyyy'}} &amp; {{l.InseminationTime| date: 'mediumTime'}}

                                                      </td>
                                                      <td class="td-padding text-align-center">

                                                        {{l.NtimesInformed}}


                                                      </td>

                                                      <td class="td-padding ">

                                                        {{l.ProcessedByName}}
                                                      </td>
                                                      <td class="td-padding text-align-center white-spce-pre">
                                                        <div class="broder-right-1px-dark">{{l.DoctorName}}</div>
                                                        <div>{{l.NurseName}}</div>
                                                      </td>



                                                      <td>
                                                        <div class="test-icons float-right" *ngIf="InseminationData2">
                                                          <a (click)="Addactivity()" class="nav-link-hand" title="Remove" *ngIf="InseminationData2.ActivityStatus !=='Completed'"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                                          <a (click)="Editactivity(l)" class="nav-link-hand education-navlink  color-Assign" title="Edit" *ngIf="InseminationData2.ActivityStatus !=='Completed'">
                                                            <span class="badge"><i class="fas fa-pencil-alt nav-link-hand"></i></span>
                                                          </a>
                                                        </div>
                                                      </td>

                                                    </tr>


                                                  </tbody>

                                                </table>

                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>


                          </div>
                        </div>
                        <div class="accordion" id="accordionExample2" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">

                          <div class="card margin-bottom-5px">
                            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                              <div class="row">
                                <div class="col-md-4">
                                  <h5 class="mb-0 height-24px">
                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                      Oocytes For Storage
                                    </button>
                                  </h5>
                                </div>
                                <div class="col-md-8">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                  <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                </div>
                                <!--<div class="col-md-6">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                </div>-->
                              </div>


                            </div>

                            <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                              <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                                <div class="card margin-bottom-0px margin-top-10">

                                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                    <div class="row margin-bottom-10px" *ngIf="CurrentIvfOocyteEmbryoStorageByCodeController ==null || CurrentIvfOocyteEmbryoStorageByCodeController.length == 0">
                                      <!--<button (click)="Store()" class="btn font-size-13px actions-btn-prime margin-left-auto margin-right-auto">Init Store</button>-->
                                    </div>
                                    <div class="row">
                                      <div class="col-md-12 ">
                                        <div class="table-component" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                          <div class="table-responsive">


                                            <table class="table table-striped margin-left-zero overflow-y-hidden">

                                              <thead class="">
                                                <tr>
                                                  <th class="min-width-0px padding-top-4px padding-bottom-4px"></th>


                                                  <th class="padding-top-4px padding-bottom-4px">Well#</th>

                                                  <th class="padding-top-4px padding-bottom-4px">Morphology</th>
                                                  <th class="white-space-preline padding-top-4px padding-bottom-4px">Storage</th>
                                                  <th class="padding-top-4px padding-bottom-4px">Details</th>
                                                  <th class="padding-top-4px padding-bottom-4px padding-right-0px">Status</th>
                                                  <th class="padding-top-4px padding-bottom-4px padding-left-0px padding-right-0px" *ngIf="InseminationData2.ActivityStatus !=='Completed'"></th>
                                                </tr>
                                              </thead>
                                              <tbody class="table-body">
                                                <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                                <!--</ng-container>-->
                                                <tr *ngFor="let l of CurrentIvfOocyteEmbryoStorageByCodeController">
                                                  <td class="td-padding padding-all-0px ">

                                                    <input type="checkbox" name="l.IsSelected"
                                                           [(ngModel)]="l.IsSelected">
                                                    <i class="input-helper"></i>

                                                  </td>


                                                  <td class="text-align-center padding-all-0px">{{l.WellNo}}</td>

                                                  <td class="padding-top-0px padding-bottom-0px">{{l.Morphology}}</td>

                                                  <td class="padding-all-0px text-align-center">
                                                    <!--<CodeTypeValue CodeType="OST" [(ngModel)]="l.StorageUnitType" SelectedValue="l.StorageUnitType"
                                                    required></CodeTypeValue>-->
                                                    {{l.StorageUnitType}}
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px">
                                                    <!--<input type="text" class="form-control" min="1" max="10" placeholder="Details"
                                                           id="l.StorageUnitDetails"
                                                           [(ngModel)]="l.StorageUnitDetails"
                                                           name="l.StorageUnitDetails" #Remarks="ngModel"
                                                           maxlength="100">
                                                    <small class="form-text text-danger"
                                                           *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                                    <small class="form-text text-danger"
                                                           *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>-->
                                                    {{l.StorageUnitDetails}}
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px padding-right-0px">
                                                    <a class="color-datacolor font-weight-normal text-decoration font-size-14">
                                                      <i class="fas fa-circle color-Assign nav-link-hand  ">
                                                      </i>
                                                    </a>
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px" *ngIf="InseminationData2.ActivityStatus !=='Completed'">
                                                    <button type="submit" (click)="onSubmit2(l)" class="actions-btn-prime-insemination nav-link-hand float-right" title="Save" *ngIf="l?.IsSelected">Select For Insemination</button>


                                                  </td>



                                                </tr>
                                              </tbody>

                                            </table>

                                          </div>
                                        </div>

                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>


                        </div>
                        <div class="accordion margin-bottom-20px margin-top-10" id="accordionExampledrop1" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                          <div class="card margin-bottom-5px">
                            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingdrop1">
                              <div class="row">
                                <div class="col-md-4">
                                  <h5 class="mb-0 height-24px">
                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsedrop1" aria-expanded="true" aria-controls="collapsedrop1">
                                      Insemination
                                    </button>
                                  </h5>
                                </div>
                                <div class="col-md-8 " *ngIf="InseminationData2">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                  <button type="button" (click)="AddInsemination()"
                                          class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" *ngIf="InseminationData2.ActivityStatus !=='Completed'"
                                          name="upload">
                                    <i class="fas fa-plus font-size-11"></i>
                                  </button>
                                </div>
                              </div>


                            </div>

                            <div id="collapsedrop1" class="collapse show" aria-labelledby="headingdrop1" data-parent="#accordionExampledrop1">
                              <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div class="card margin-bottom-0px">

                                      <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                        <div class="table-component margin-bottom-0px padding-all-5px">
                                          <div class="table-responsive">


                                            <table class="table table-striped margin-left-zero overflow-y-hidden">
                                              <thead class="">
                                                <tr>
                                                  <th class="padding-top-4px padding-bottom-4px font-size-12px">Technique</th>
                                                  <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px">Injected/Inseminated</th>

                                                  <th class="padding-top-4px padding-bottom-4px font-size-12px">Details</th>
                                                  <th class="padding-top-4px padding-bottom-4px font-size-12px">Embryologist</th>
                                                  <th class="td-well-width-79px padding-top-4px padding-bottom-4px"></th>
                                                </tr>
                                              </thead>

                                              <tbody class="table-body">
                                                <tr *ngFor="let l of CurrentIvfCycleInseminationByCycleController">
                                                  <td class="padding-top-0px padding-bottom-0px ">


                                                    <!--<CodeTypeValue CodeType="InsTe"
                                                                   id="l.Technique"
                                                                   [(ngModel)]="l.Technique" SelectedValue="l.Technique"
                                                                   name="l.Technique" required>
                                                    </CodeTypeValue>-->
                                                    <label class="margin-bottom-0px">{{l.Technique}}</label>
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px text-align-center">
                                                    <!--<input type="text" class="form-control text-align-right" placeholder=""
                                                           [(ngModel)]="l.OocyteCount"
                                                           maxlength="2" required>-->
                                                    <label class="margin-bottom-0px">{{l.OocyteCount}}</label>
                                                  </td>


                                                  <td class="padding-top-0px padding-bottom-0px">
                                                    <!--<input type="text" class="form-control" placeholder=""
                                                           [(ngModel)]="l.Remarks"
                                                           maxlength="2" required>-->
                                                    <label class="margin-bottom-0px">{{l.Remarks}}</label>
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px">
                                                    <!--<input type="text" class="form-control" placeholder=""
                                                           [(ngModel)]="l.PrescribedByName"
                                                           maxlength="2" required>-->
                                                    <label class="margin-bottom-0px">{{l.PrescribedByName}}</label>
                                                  </td>
                                                  <td class="padding-all-0px">
                                                    <div class="test-icons" *ngIf="InseminationData2">
                                                      <a class="font-size-16px color-Assign" (click)="Editinsemi(l)"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand" *ngIf="InseminationData2.ActivityStatus !=='Completed'"></i></a>
                                                      <!--<a class="nav-link-hand font-size-20px margin-left-15px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand" *ngIf="InseminationData2.ActivityStatus !=='Completed'"></i></a>-->
                                                    </div>
                                                  </td>
                                                </tr>

                                              </tbody>
                                            </table>

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card margin-top-10" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                          <!--<div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
                            <div class="row nav-link-hand margin-right-0px" id="edit-link">
                              <div class="col-md-6 padding-right-0px">
                                <label class="margin-bottom-0px font-size-16px font-weight-normal">
                                  Insemination Log
                                </label>
                              </div>
                              <div class="col-md-6  padding-right-0px display-edit">

                                <div class="row float-right">

                                  <div class="col-md-1">
                                    <a class="nav-link-hand education-navlink data-color-new" title="print">
                                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                                    </a>
                                  </div>
                                </div>




                              </div>

                            </div>
                          </div>-->
                          <div class="card-body padding-all-0px">
                            <div class="accordion margin-bottom-20px margin-top-10" id="accordionExample1">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                          Insemination Log
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="InseminationData2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="button"
                                              class="btn  btn-sm button-ivfactivity  background-primary border-all-secondary float-right" id="FileUpload" (click)="Addactivity()"
                                              name="upload" *ngIf="InseminationData2.ActivityStatus !=='Completed'">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                    </div>
                                  </div>


                                </div>

                                <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample1">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="card margin-bottom-0px background-lightpink">

                                          <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                            <div class="table-component margin-bottom-0px padding-all-5px">
                                              <div class="table-responsive">


                                                <table class="table table-striped margin-left-zero overflow-y-hidden">

                                                  <thead class="">
                                                    <tr>
                                                      <th class="min-width-0px">Date &amp; Time</th>

                                                      <!--<th class="min-width-0px">No of times per hour</th>-->
                                                      <th class="padding-left-5px">Done By</th>

                                                      <th>Embryologist</th>
                                                      <th></th>
                                                    </tr>
                                                  </thead>
                                                  <tbody class="table-body">

                                                    <tr *ngFor="let l of CurrentIvfCycleInseminationLogByCycleWithDOCController">
                                                      <td class="td-padding">


                                                        {{l.InseminationDate| date:'dd-MMM-yyyy'}} &amp; {{l.InseminationTimeText}}

                                                      </td>
                                                      <!--<td class="td-padding text-align-center">

                                                        {{l.NtimesInformed}}


                                                      </td>-->

                                                      <td class="td-padding ">

                                                        {{l.ProcessedByName}}
                                                      </td>
                                                      <td class="td-padding white-spce-pre">
                                                        <div class="broder-right-1px-dark">{{l.DoctorName}}</div>
                                                        <div>{{l.NurseName}}</div>
                                                      </td>



                                                      <td class="padding-top-0px padding-bottom-0px">
                                                        <div class="test-icons float-right" *ngIf="InseminationData2">
                                                          <!--<a (click)="Addactivity()" class="nav-link-hand font-size-16px" title="Remove" *ngIf="InseminationData2.ActivityStatus !=='Completed'"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>-->
                                                          <a (click)="Editactivity(l)" class="nav-link-hand font-size-20px color-Assign" title="Edit" *ngIf="InseminationData2.ActivityStatus !=='Completed'">
                                                            <span class="badge"><i class="fas fa-pencil-alt nav-link-hand"></i></span>
                                                          </a>
                                                        </div>
                                                      </td>

                                                    </tr>


                                                  </tbody>

                                                </table>

                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>


                          </div>
                        </div>


                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 padding-left-0px background-white" *ngIf="ScanDetails">
          <div class="row">
            <div class="position-fixed-Activities">

              <div class="col-md-12">
                <div class="card">
                  <div class="card-header wh-header  padding-left-0px padding-right-0px border-bottom-0px padding-top-0px">
                    <ul class="nav nav-tabs nav-tab-ivf margin-top-3px" id="tabContent">
                      <li class="active nav-link-hand margin-right-5px"><a class="nav-item-ivf active" href="#details" data-toggle="tab">Activities</a></li>
                      <li class="nav-link-hand margin-right-5px"><a class="nav-item-ivf" href="#access-security" data-toggle="tab">Forms</a></li>

                    </ul>
                  </div>
                  <div class="card-body padding-all-0px">
                    <div class="tab-content">
                      <div class="tab-pane active" id="details">
                        <!--<div class="card">
                          <div class="card-body padding-all-0px">
                            <div class="row margin-right-0px margin-left-0px margin-top-5px">
                              <div class="col-md-9 margin-left-15px padding-right-0px padding-left-0px ">
                                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                              </div>
                              <div class="col-md-2">
                                <button type="button"  class="btn btn-ivf-new  btn-sm background-primary border-all-secondary" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i></button>
                              </div>
                            </div>

                            <div class="row margin-top-10 margin-left-0px">
                              <div class="col-md-12">
                                <div class="table-component">
                                  <div class="table-responsive overflow-x">


                                    <table class="table table-striped margin-left-zero"
                                           cols="auto,2*,*,*,*,*,*,*">

                                      <thead class="">
                                        <tr>

                                          <th class="td-width-103px font-weight-normal td-padding-tb">
                                            Date
                                          </th>

                                          <th class="font-weight-normal td-padding-tb">
                                            Remarks
                                          </th>


                                          <th class="text-align-center font-weight-normal td-padding-tb">
                                            Status
                                          </th>










                                                            </tr>
                                                          </thead>

                                                          <tbody class="table-body">
                                                            <tr>

                                                              <td class="padding-right-0px td-padding-tb align-top font-size-12px">
                                                                13-JUN-19


                                                              </td>




                                                              <td class="td-padding-tb">
                                                                <div>Day 4 Grading</div>
                                                                <div class="td-padding-tb td-elipsis2">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.</div>
                                                              </td>

                                                              <td class="td-padding-tb text-align-center align-top">
                                                                <i class="fas fa-circle light-gray-badge nav-link-hand  ">
                                                                </i>
                                                              </td>

                                                            </tr>

                                                          </tbody>

                                                        </table>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                        </div>-->
                        <div *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
                          <cycleactivities [ActorCode]="SelectedpatientDetails.EggSourceActorCode" [CycleCode]="SelectedpatientDetails.TreatmentCycleCode" ActivityName="ETREC" [CanLoadReport]='CanLoadReport'></cycleactivities>
                        </div>
                        <div *ngIf="SelectedpatientDetails.EggSourceType=='Self'">
                          <cycleactivities [ActorCode]="SelectedpatientDetails.EggSourceActorCode" [CycleCode]="SelectedpatientDetails.TreatmentCycleCode" ActivityName="ETSelf" [CanLoadReport]='CanLoadReport'></cycleactivities>
                        </div>
                        <!--<cycleactivities [ActorCode]="SelectedpatientDetails.EggSourceActorCode" [CycleCode]="SelectedpatientDetails.CycleActivity"></cycleactivities>-->
                      </div>

                      <div class="tab-pane" id="access-security">
                        <div class="card">
                          <div class="card-body padding-bottom-0px padding-top-0px">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="row">
                                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                    <div class="row">


                                      <div class="col-md-12">
                                        <CustomDataByRequestType RequestedType="FDActorReports" ActorCode={{ActorCodeLoad()}}
                                                                 id="CurrentFdActorReportsDocController.TemplateName" SelectedValue=""
                                                                 [(ngModel)]="SelectedReport"
                                                                 (keyChange)="onAssignedToActorCode($event)"
                                                                 name="CurrentFdActorReportsDocController.TemplateName">
                                        </CustomDataByRequestType>
                                        <!--<CodeTypeValue CodeType="RELTP"></CodeTypeValue>-->


                                      </div>
                                      <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                                        <div *ngIf="FormData" class="margin-top-10">


                                          <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let l of FormData;let RowIndex = index">
                                            <div [id]="'accordion'+RowIndex">
                                              <div class="card-header wh-header font-size-16px  padding-top-0px padding-bottom-0px border-left-clinical padding-l-8px padding-right-0px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
                                                <h5 class="mb-0">
                                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                                                          aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                                                    {{l.Title}}

                                                  </button>
                                                </h5>

                                              </div>
                                              <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                                                   [attr.data-parent]="'#accordion'+RowIndex">
                                                <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                                                  <div class="row col-md-12 card" *ngFor="let f of l.Fields">


                                                    <div class="card-header wh-header font-size-14 padding-l-8px padding-t-6px padding-bottom-0px padding-right-0px" *ngIf="f.isHeader">
                                                      {{f.Title}}
                                                    </div>
                                                    <div class="card-body padding-bottom-0px padding-top-0px margin-left-zero">
                                                      <div *ngIf="f.isSubHeader">
                                                        <label class="font-size-14 margin-bottom-0px">{{f.Title}}</label>
                                                      </div>
                                                      <div *ngIf="f.isTextField">
                                                        <div class="row">
                                                          <div class="col-md-5 padding-right-0px">
                                                            <label class="font-size-12px margin-bottom-0px">{{f.Title}}</label>
                                                          </div>:
                                                          <div class="col-md-5">
                                                            <label class="font-size-12px margin-bottom-0px"> {{f.Value}}</label>
                                                          </div>
                                                        </div>


                                                      </div>
                                                      <div *ngIf="f.isSubChild">
                                                        <div class="row">
                                                          <div class="col-md-6">
                                                            <label class="font-size-12px margin-bottom-0px">{{f.Title}}</label>
                                                          </div>:
                                                          <div class="col-md-5">
                                                            <label class="font-size-12px margin-bottom-0px"> {{f.Value}}</label>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div *ngIf="f.Remarks">
                                                        <label class="margin-left-10px margin-bottom-0px">{{f.Remarks}}</label>
                                                      </div>
                                                      <div *ngIf="f.HasSeparator">
                                                        <div class="border-bottom-light"></div>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <!--<label>{{f.Title}}</label>
                                                  <label class="margin-left-auto"></label>-->

                                                </div>
                                              </div>
                                            </div>
                                            <!--<div *ngFor="let l of CurrentFdActorReportsDocController">
                                              <label>{{l.TemplateName}}</label>
                                            </div>-->
                                          </div>

                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>





      </div>
    </div>

  </div>
  <div class="row" *ngIf="Showivf">
    <div class="col-md-12">
      <ivfworkbench></ivfworkbench>
    </div>
  </div>
  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
